import { useEffect } from 'react';
import { IExtendedRelayPKP } from '@shared/types/lit-protocol';
import { createOrUpdateLiveNotification } from '@/lib/db/DBNotificationHelpers';
import useGetLocation from '../utilities/useGetLocation';
import useAppDetails from '../utilities/useAppDetails';
export default function useWebNotifications(PKP: IExtendedRelayPKP) {
  const {
    data: locationData
  } = useGetLocation();
  const {
    isNativeApp
  } = useAppDetails();
  console.log('SWSW isNativeApp', isNativeApp);
  useEffect(() => {
    const initializeNotifications = async () => {
      if (!('serviceWorker' in navigator)) {
        console.log('SWSW Service Worker not supported');
        return;
      }
      try {
        // Register Service Worker
        const registration = await navigator.serviceWorker.register('/sw.js');
        console.log('SWSW Registration successful', registration);

        // Request notification permission
        const permission = await Notification.requestPermission();
        console.log('SWSW Registration Notification permission:', permission);
        if (permission !== 'granted') {
          console.log('SWSW Notification permission denied');
          return;
        }
        console.log('SWSW Registration Notification permission granted');

        // Get push subscription
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: 'BAWygIC0_de59HudSbGncKbs2ej0VAUJPxSkCPfUO-NzUOSJRK15OH_RSWuQY1ZqIBxLFyKAa0IZdvh1BOxWh_8'
        });
        console.log('SWSW Registration Notification subscription:', subscription);

        // Update live notification with subscription as expo token
        await createOrUpdateLiveNotification({
          expo_token: JSON.stringify(subscription),
          location_data: locationData,
          device_data: null,
          pkp_eth_address: PKP?.ethAddress,
          token_type: 'browser'
        });
      } catch (error) {
        console.log('SWSW Notification setup failed:', error.message);
      }
    };
    if (!isNativeApp) {
      initializeNotifications();
    }

    // Cleanup function
    return () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('message', null);
      }
    };
  }, [PKP, locationData, isNativeApp]);
}